import styles from "./Offer.module.scss";
import Offer_icon_1 from "../../assets/images/offer/offer_img_1.svg";
import Offer_icon_2 from "../../assets/images/offer/offer_img_2.svg";
import Offer_icon_3 from "../../assets/images/offer/offer_img_3.svg";
import Offer_icon_4 from "../../assets/images/offer/offer_img_4.svg";
import Offer_icon_5 from "../../assets/images/offer/offer_img_5.svg";
import Offer_icon_6 from "../../assets/images/offer/offer_img_6.svg";

export const Offer = () => {
  const {
    section__offer,
    wrapper__offer,
    offer__title,
    offer__list,
    offer__item,
    offer__header,
    offer__slogan,
    offer__icon,
    offer__content,
  } = styles;

  return (
    <section className={section__offer}>
      <div className={wrapper__offer}>
        <h2 className={offer__title} data-aos="fade-right" data-aos-delay="100">Co otrzymasz w ofercie</h2>
        <ul className={offer__list}>
          <li className={offer__item} data-aos="zoom-in-out" data-aos-delay="200">
            <div className={offer__header}>
              <p className={offer__slogan}>Wersja mobilna</p>
              <img className={offer__icon} src={Offer_icon_1} alt="icon" />
            </div>
            <div className={offer__content}>
              Przygotuję dla Ciebie stronę, którą można wyświetlać nie tylko na
              komputerze, ale również na telefonie i tablecie.
            </div>
          </li>
          <li className={offer__item} data-aos="zoom-in-out" data-aos-delay="300">
            <div className={offer__header}>
              <p className={offer__slogan}>Nowoczesny wygląd</p>
              <img className={offer__icon} src={Offer_icon_2} alt="icon" />
            </div>
            <div className={offer__content}>
              Stworzę dla Ciebie stronę o nowoczesnym i profesjonalnym
              wyglądzie, który będzie przyciągać nowych klientów do współpracy.
            </div>
          </li>
          <li className={offer__item} data-aos="zoom-in-out" data-aos-delay="400">
            <div className={offer__header}>
              <p className={offer__slogan}>Projekt graficzny</p>
              <img className={offer__icon} src={Offer_icon_3} alt="icon" />
            </div>
            <div className={offer__content}>
              Przygotuję dla Ciebie, projekt graficzny strony o schludnym
              i przejrzystym wyglądzie.
            </div>
          </li>
          <li className={offer__item} data-aos="zoom-in-out" data-aos-delay="500">
            <div className={offer__header}>
              <p className={offer__slogan}>Podejście biznesowe</p>
              <img className={offer__icon} src={Offer_icon_4} alt="icon" />
            </div>
            <div className={offer__content}>
              Dzięki szczegółowej osobistej analizy, stworzona strona będzie
              idealnie spełniała twoje potrzeby oraz wymagania biznesowe.
            </div>
          </li>
          <li className={offer__item} data-aos="zoom-in-out" data-aos-delay="600">
            <div className={offer__header}>
              <p className={offer__slogan}>Bezpieczeństwo</p>
              <img className={offer__icon} src={Offer_icon_5} alt="icon" />
            </div>
            <div className={offer__content}>
              Strona będzie hostowana na szybkich i bezpiecznych serwerach
              zapewniających szyfrowanie przy pomocy certyfikatu SSL (zielona
              kłódka)
            </div>
          </li>
          <li className={offer__item}data-aos="zoom-in-out" data-aos-delay="700">
            <div className={offer__header}>
              <p className={offer__slogan}>Wsparcie i pomoc</p>
              <img className={offer__icon} src={Offer_icon_6} alt="icon" />
            </div>
            <div className={offer__content}>
              Oferuję wsparcie oraz pomoc przy użytkowaniu utworzonej przeze
              mnie strony internetowej. Nie zostawię Cię samego z napotkanym
              problemem.
            </div>
          </li>
        </ul>
        <div data-aos="fade-up" data-aos-delay="200">          
          <a href="#contact">
            <button className="button">Zamów usługę</button>
          </a>          
        </div>        
      </div>
    </section>
  );
};
